var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.90549 10.9429C9.71351 10.9589 9.53746 10.8629 9.36147 10.7669C7.74547 9.8229 6.36947 8.47891 5.40947 6.87891C5.23348 6.60694 5.07348 6.28694 5.1375 5.96694C5.24948 5.35891 6.0175 5.11891 6.24151 4.54294C6.44954 4.04695 6.1775 3.48695 5.8575 3.05494C5.32947 2.33494 4.6575 1.71094 3.8895 1.24694C3.52147 1.02298 3.12147 0.830954 2.6895 0.798968C0.753498 0.702978 0.641498 3.93497 0.897498 5.19897C1.16947 6.51094 1.82552 7.72697 2.5935 8.83097C4.4015 11.455 6.8815 13.679 9.8895 14.735C10.9455 15.103 12.0815 15.3269 13.1695 15.071C13.7135 14.9429 14.2255 14.7029 14.6095 14.2869C14.9935 13.8869 15.2015 13.311 15.1055 12.7669C15.0095 12.2069 14.6255 11.7589 14.2415 11.3589C13.6815 10.783 13.0575 10.2709 12.3855 9.82294C12.2575 9.74294 12.1295 9.66294 11.9855 9.64695C11.8255 9.63096 11.6815 9.71096 11.5374 9.79097C11.1374 10.015 10.7694 10.287 10.4494 10.591C10.3054 10.735 10.1454 10.879 9.95343 10.911C9.93749 10.927 9.9215 10.943 9.90551 10.943L9.90549 10.9429Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneWhiteIcon);
export default __webpack_public_path__ + "static/media/phoneWhiteIcon.c192ec350cdd9e1406d6e50373196f80.svg";
export { ForwardRef as ReactComponent };